<template>
  <div class="footer">
    <div class="content">
      <div class="menu">
        <div class="product">
          <div class="title">产品和服务</div>
          <p v-for="(menu, menuindex) in Menu" :key="menuindex" @click="goroute(menu.pathName)">{{ menu.menuName }}</p>
        </div>
        <div class="border"></div>
        <div class="concatus">
          <div class="title">联系我们</div>
          <p>中国资讯行客户服务中心（北京）:</p>
          <p><span>infobank@infobank.cn</span><span>(86)010-84134405</span></p>
          <p>中国资讯行客户服务中心（上海）:</p>
          <p><span>infobank@infobank.cn</span><span>(86)021-58586536</span></p>
        </div>
        <div class="border"></div>
        <div class="aboutus">
          <div class="title">关于我们</div>
          <p @click="goroute('aboutus')">公司简介</p>
        </div>
      </div>
      <div class="copyright">
        <p>京ICP证090496号<span></span></p>
        <p class="beian">
          <img src="@/assets/image/ico_beian.png" />京公网安备<span @click="openWindow()">11010802036497号</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      Menu: [
        {
          menuName: '政务舆情服务',
          pathName: 'zwyq',
        },
        {
          menuName: '企业/品牌舆情监测',
          pathName: 'yqjc',
        },
        {
          menuName: '搜数网',
          pathName: 'ssw',
        },
        {
          menuName: '高校财经数据库',
          pathName: 'gxcj',
        },
        {
          menuName: '京津冀协同发展战略研究网',
          pathName: 'jingjinji',
        },
        {
          menuName: '台湾问题研究网',
          pathName: 'twwt',
        },
        {
          menuName: '开发强国数据库',
          pathName: 'kfqg',
        },
        {
          menuName: '个性化平台定制-EIP',
          pathName: 'case',
        },
      ],
    }
  },
  methods: {
    // 跳转页面
    goroute(name) {
      this.$router.push({ name: name })
    },
    openWindow() {
      window.location.href = 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802036497'
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import '../styles/global.less';
.footer {
  width: 100%;
  background: #0e121a;
  overflow: hidden;
  .content {
    width: 80%;
    margin: 48px auto 32px;
    .menu {
      display: flex;
      justify-content: space-around;
      align-items: flex-start;
      cursor: pointer;
      .title {
        margin: 0 0 32px;
        font-size: 20px;
        font-weight: 500;
        text-align: left;
        color: #ffffff;
      }
      p {
        margin: 16px 0;
        text-align: left;
        color: #ffffff;
        span {
          margin-right: 15px;
          color: #80baff;
        }
      }
      .border {
        height: 330px;
        border-right: 1px solid rgba(255, 255, 255, 0.2);
      }
    }
    .copyright {
      display: flex;
      justify-content: center;
      margin: 48px 0 0;
      color: #ffffff;
      span {
        margin-right: 15px;
        color: #80baff;
      }
      .beian {
        display: flex;
        align-items: center;
        img {
          width: 20px;
          height: 20px;
          margin-right: 5px;
        }
      }
    }
  }
}
</style>
